import React, { useState } from "react";
import styles from "../styles/UlcPremiumCalculator.module.css";

const GovtNomineeFlatForm = () => {
  const [formData, setFormData] = useState({
    district: "",
    taluka: "",
    village: "",
    surveyNumber: "",
    builtUpArea: "",
    possessionYears: "",
    rate: "",
    premium: "",
  });

  // Handle input changes
  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({ ...prev, [name]: value }));
  };

  // Handle possession years selection and auto-set rate
  const handlePossessionChange = (e) => {
    const value = e.target.value;
    let rate = "";

    if (value === "more5") rate = 250;
    else if (value === "more10") rate = 125;

    setFormData((prev) => ({
      ...prev,
      possessionYears: value,
      rate: rate,
    }));
  };

  // Handle form submission and calculation
  const handleSubmit = (e) => {
    e.preventDefault();
    const area = parseFloat(formData.builtUpArea) || 0;
    const rate = parseFloat(formData.rate) || 0;
    const premium = area * rate;

    setFormData((prev) => ({
      ...prev,
      premium: premium.toFixed(2),
    }));
  };

  return (
    <form className={styles.calculatorULC_form} onSubmit={handleSubmit}>
      <div className={styles.calculatorULC_inputGroup}>
        <label>District</label>
        <select
          name="district"
          value={formData.district}
          onChange={handleChange}
          className={styles.calculatorULC_input}
        >
          <option value="">Select District</option>
           <option value="Kolhapur">Kolhapur</option>
          <option value="Mumbai">Mumbai</option>
          <option value="Nagpur">Nagpur</option>
          <option value="Nashik">Nashik</option>
          <option value="Pune">Pune</option>
          <option value="Sangli">Sangli</option>
          <option value="Solapur">Solapur</option>
          <option value="Thane">Thane</option>
          <option value="Ulhasnagar">Ulhasnagar</option>
        </select>
      </div>

      <div className={styles.calculatorULC_inputGroup}>
        <label>Taluka</label>
        <input
          type="text"
          name="taluka"
          value={formData.taluka}
          onChange={handleChange}
          className={styles.calculatorULC_input}
          placeholder="Enter Taluka"
        />
      </div>

      <div className={styles.calculatorULC_inputGroup}>
        <label>Village</label>
        <input
          type="text"
          name="village"
          value={formData.village}
          onChange={handleChange}
          className={styles.calculatorULC_input}
          placeholder="Enter Village"
        />
      </div>

      <div className={styles.calculatorULC_inputGroup}>
        <label>Survey Number</label>
        <input
          type="text"
          name="surveyNumber"
          value={formData.surveyNumber}
          onChange={handleChange}
          className={styles.calculatorULC_input}
          placeholder="Enter Survey Number"
        />
      </div>

      <div className={styles.calculatorULC_inputGroup}>
        <label>Built-up Area of Flat (sq.ft.)</label>
        <input
          type="number"
          step="0.01"
          name="builtUpArea"
          value={formData.builtUpArea}
          onChange={handleChange}
          className={styles.calculatorULC_input}
          placeholder="Enter Area"
        />
      </div>

      <div className={styles.calculatorULC_inputGroup}>
        <label>Number of years in possession of flat</label>
        <select
          name="possessionYears"
          value={formData.possessionYears}
          onChange={handlePossessionChange}
          className={styles.calculatorULC_input}
        >
          <option value="">Select years</option>
          <option value="more5">More than 5 years</option>
          <option value="more10">More than 10 years</option>
        </select>
      </div>

      <div className={styles.calculatorULC_inputGroup}>
        <label>Rate (Rs/sq.ft)</label>
        <input
          type="text"
          name="rate"
          value={formData.rate}
          readOnly
          className={styles.calculatorULC_input}
          placeholder="Premium Factor (₹/sq.ft)"
        />
      </div>


      <button type="submit" className={styles.calculatorULC_submitButton}>
        Submit
      </button>

      
      <div className={styles.calculatorULC_inputGroup}>
        <label>ULC Premium Amount (₹)</label>
        <input
          type="text"
          name="premium"
          value={formData.premium}
          readOnly
          className={styles.calculatorULC_input}
          placeholder="Calculated Premium"
        />
      </div>
      
    </form>
  );
};

export default GovtNomineeFlatForm;
